export enum PROGRESS_SEGMENT {
  NO_MEMBERS = "noMembers",
  DONE = "done",
  IN_PROGRESS = "inProgress",
  NOT_STARTED = "notStarted"
}
